<template>
  <div>
    <Drawer
      :value="visible"
      @on-close="visible = false"
      title="人群包使用情况"
      width="400"
      :mask-closable="true"
      :z-index="600"
      class-name="usage-drawer"
      transfer
    >
    <div v-if="loading" style="text-align: center; padding: 40px 0">
      <Spin size="large" />
    </div>
    <div v-else class="usage-content">
      <div class="crowd-name">人群包：{{ crowdName }}</div>

      <div
        class="usage-section"
        v-if="usageData.popupPushItems && usageData.popupPushItems.length"
      >
        <div class="section-title">弹窗推送</div>
        <div
          v-for="item in usageData.popupPushItems"
          :key="'popup_' + item.refId"
          class="usage-item"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <span>{{ item.refName }}</span>
          <a @click="handleViewDetail(item, 'popupPush')">查看详情</a>
        </div>
      </div>

      <div
        class="usage-section"
        v-if="usageData.h5ActivityItems && usageData.h5ActivityItems.length"
      >
        <div class="section-title">H5活动推送</div>
        <div
          v-for="item in usageData.h5ActivityItems"
          :key="'activity_' + item.refId"
          class="usage-item"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <span>{{ item.refName }}</span>
          <a @click="handleViewDetail(item, 'h5Activity')">查看详情</a>
        </div>
      </div>
      <div
        class="usage-section"
        v-if="usageData.rechargeTemplateItems && usageData.rechargeTemplateItems.length"
      >
        <div class="section-title">充值面板</div>
        <div
          v-for="item in usageData.rechargeTemplateItems"
          :key="'pay_' + item.refId"
          class="usage-item"
        >
          {{ item.refName }}
        </div>
      </div>

      <div
        class="usage-section"
        v-if="usageData.thirdPayItems && usageData.thirdPayItems.length"
      >
        <div class="section-title">三方支付</div>
        <div
          v-for="item in usageData.thirdPayItems"
          :key="'pay_' + item.refId"
          class="usage-item"
        >
          {{ item.refName }}
        </div>
      </div>

      <div
        class="usage-section"
        v-if="usageData.adStrategyItems && usageData.adStrategyItems.length"
      >
        <div class="section-title">广告策略</div>
        <div
          v-for="item in usageData.adStrategyItems"
          :key="'ad_' + item.refId"
          class="usage-item"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <span>{{ item.refName }}</span>
          <a @click="handleViewDetail(item, 'adStrategy')">查看详情</a>
        </div>
      </div>

      <div
        class="usage-section"
        v-if="usageData.abTestItems && usageData.abTestItems.length"
      >
        <div class="section-title">AB实验</div>
        <div
          v-for="item in usageData.abTestItems"
          :key="'ab_' + item.refId"
          class="usage-item"
        >
          {{ item.refName }}
        </div>
      </div>

      <div v-if="!hasAnyUsage" class="empty-usage">暂无使用记录</div>
    </div>
  </Drawer>
  <ActivityEditModal
    v-model="activityDetailVisible"
    :data="activityDetailForm"
    :readonly="true"
  />
  <PopupEditModal
    v-model="popupDetailVisible"
    :data="popupDetailForm"
    :readonly="true"
  />
  <AdEditModal
    v-model="adDetailVisible"
    :data="adDetailForm"
    :readonly="true"
  />
  </div>
</template>

<script>
import { getCrowdUsage } from '@/api/crowd'
import { getActivityConfigDetail } from '@/api/activity'
import { getPopupInfo } from '@/api/popup'
import { getAdStrategyInfo } from '@/api/advertise'
import ActivityEditModal from '@/view/activityConfig/components/EditModal.vue'
import PopupEditModal from '@/view/notification/components/EditModal.vue'
import AdEditModal from '@/view/advertise/components/EditModal.vue'

export default {
  name: 'UsageDrawer',
  components: {
    ActivityEditModal,
    PopupEditModal,
    AdEditModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    crowdId: {
      type: [Number, String],
      default: null
    },
    crowdName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      usageData: {},
      activityDetailVisible: false,
      activityDetailForm: {},
      popupDetailVisible: false,
      popupDetailForm: {},
      adDetailVisible: false,
      adDetailForm: {},
      drawerWasVisible: false
    }
  },
  computed: {
    hasAnyUsage() {
      const d = this.usageData
      return (
        (d.popupPushItems && d.popupPushItems.length) ||
        (d.h5ActivityItems && d.h5ActivityItems.length) ||
        (d.thirdPayItems && d.thirdPayItems.length) ||
        (d.rechargeTemplateItems && d.rechargeTemplateItems.length) ||
        (d.adStrategyItems && d.adStrategyItems.length) ||
        (d.abTestItems && d.abTestItems.length)
      )
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val && this.crowdId) {
        this.fetchUsage()
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
    activityDetailVisible(val) {
      if (!val && this.drawerWasVisible) {
        this.visible = true
      }
    },
    popupDetailVisible(val) {
      if (!val && this.drawerWasVisible) {
        this.visible = true
      }
    },
    adDetailVisible(val) {
      if (!val && this.drawerWasVisible) {
        this.visible = true
      }
    }
  },
  methods: {
    async fetchUsage() {
      this.loading = true
      try {
        const { data } = await getCrowdUsage(this.crowdId)
        this.usageData = data || {}
      } catch (e) {
        this.$Message.error('获取使用情况失败')
      } finally {
        this.loading = false
      }
    },
    async handleViewDetail(item, type) {
      this.drawerWasVisible = this.visible
      this.visible = false
      if (type === 'h5Activity') {
        try {
          const { data } = await getActivityConfigDetail(item.refId)
          this.activityDetailForm = data
          this.activityDetailVisible = true
        } catch (e) {
          this.$Message.error('获取活动推送详情失败')
        }
        return
      }
      if (type === 'popupPush') {
        try {
          const { data } = await getPopupInfo(item.refId)
          this.popupDetailForm = data
          this.popupDetailVisible = true
        } catch (e) {
          this.$Message.error('获取弹窗推送详情失败')
        }
        return
      }
      if (type === 'adStrategy') {
        try {
          const { data } = await getAdStrategyInfo(item.refId)
          this.adDetailForm = data
          this.adDetailVisible = true
        } catch (e) {
          this.$Message.error('获取广告策略详情失败')
        }
        return
      }
    }
  }
}</script>
<style>
.usage-drawer.ivu-drawer {
  z-index: 600 !important;
}
.usage-drawer.ivu-drawer-mask {
  z-index: 599 !important;
}
</style>

<style scoped lang="less">
.usage-content {
  .crowd-name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #17233d;
  }

  .usage-section {
    margin-bottom: 20px;

    .section-title {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 10px;
      color: #17233d;
    }

    .usage-item {
      padding: 8px 12px;
      background: #f8f8f9;
      border-radius: 4px;
      margin-bottom: 6px;
      color: #515a6e;
      font-size: 13px;
    }
  }

  .empty-usage {
    text-align: center;
    color: #c5c8ce;
    padding: 40px 0;
    font-size: 14px;
  }
}
</style>